import React from 'react';

import { StyledTrackingOrderStepList } from './TrackingOrderStepList.styles';

import { TrackingOrderStepListProps } from './TrackingOrderStepList.types';

const TrackingOrderStepList = ({
  currentStep,
  stepNumber,
  currentStepIndex = 0,
  currentStepContent,
  stepContentList = [],
  componentClassname = 'tracking-order-step-list',
  customClassnames = '',
  customStyle = '',
}: TrackingOrderStepListProps) => {
  return (
    <StyledTrackingOrderStepList
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      <div className={`${componentClassname}__stepper`}>
        {[...Array(stepNumber)].map((step, index) => (
          <div
            key={index}
            className={`${componentClassname}__step-item ${
              index === 0 ? `${componentClassname}__step-item--is-first` : ''
            } ${
              index + 1 === stepNumber
                ? `${componentClassname}__step-item--is-last`
                : ''
            } ${
              index === currentStepIndex
                ? `${componentClassname}__step-item--is-current`
                : ''
            }`}
          >
            <div
              key={index}
              className={`${componentClassname}__step-item-inner`}
            >
              {stepContentList[index]}

              {index === currentStepIndex && currentStepContent}
            </div>
            {index === currentStepIndex && currentStep && (
              <div className={`${componentClassname}__stepper-status`}>
                {currentStep.titleSlot && (
                  <div
                    className={`${componentClassname}__stepper-status-title`}
                  >
                    {currentStep.titleSlot}
                  </div>
                )}
                {currentStep.dateSlot && (
                  <div className={`${componentClassname}__stepper-status-date`}>
                    {currentStep.dateSlot}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </StyledTrackingOrderStepList>
  );
};
TrackingOrderStepList.displayName = 'TrackingOrderStepList';

export default TrackingOrderStepList;
